import { Portal } from '@reach/portal';
import cl from 'classnames';
import * as React from 'react';
import { useSlate } from 'slate-react';

import { isCollapsed } from '../../../../slatePlugins/common/queries/isCollapsed';
import { BalloonToolbarProps } from '../../../../slatePlugins/components/Toolbar/BalloonToolbar/BalloonToolbar.types';
import { setPositionAtSelection } from '../../../../slatePlugins/components/Toolbar/BalloonToolbar/setPositionAtSelection';
import { isAtMiddleOfBlock } from '../../helpers/selection';
import { BallonToolbarMain } from '../balloon-toolbar-on-expanded/BalloonToolbarOnExpanded';
import { PreventHiddenToolbarProps, withPreventHiddenToolbar } from '../prevent-toolbar-hidden/withPreventHiddenToolbar';
import { StyledToolbar } from '../StyledToolbar';

interface BalloonToolbarOnCollapsedProps extends BalloonToolbarProps, PreventHiddenToolbarProps {
  type: string;
}

const BalloonToolbarOnCollapsedBase = (props: BalloonToolbarOnCollapsedProps) => {
  const {
    className,
    children,
    direction = 'top',
    theme = 'dark',
    arrow = false,
    type,
    preventToolbarHidden,
  } = props;

  const editor = useSlate();
  const ref = React.useRef<HTMLDivElement>(null);

  let hidden = true;
  if (preventToolbarHidden) {
    hidden = false;
  } else if (isCollapsed(editor.selection)) {
    hidden = !isAtMiddleOfBlock(editor, type);
  }

  React.useEffect(() => {
    if (!hidden) {
      setPositionAtSelection(ref.current, direction);
    }
  }, [direction, hidden]);

  return (
    <Portal>
      <BallonToolbarMain className={cl({ hidden })}>
        <StyledToolbar
          ref={ref}
          className={cl(className, 'dol-balloon-toolbar')}
          $hidden={hidden}
          $theme={theme}
          $arrow={arrow}
        >
          {children}
        </StyledToolbar>
      </BallonToolbarMain>
    </Portal>
  );
};

export const BalloonToolbarOnCollapsed = withPreventHiddenToolbar(BalloonToolbarOnCollapsedBase);
